export enum BorderType {
  Solid = 'SOLID',
  HalfSolid = 'HALF_SOLID',
  Dotted = 'DOTTED',
}
